import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { mockJobs } from '../data/mockData';

const { FiSearch, FiMapPin, FiBriefcase, FiClock, FiFilter } = FiIcons;

const Jobs = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('Alle');

  const categories = ['Alle', 'Gewerblich', 'Kaufmännisch', 'Logistik', 'Pflege', 'Ingenieurwesen'];

  const filteredJobs = mockJobs.filter(job => {
    const matchesSearch = job.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          job.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'Alle' || job.category === filterCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <PageWrapper className="bg-slate-50">
      {/* Header / Search Area */}
      <div className="bg-blue-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6 text-center">Stellenangebote</h1>
          <p className="text-blue-200 text-center mb-10 max-w-2xl mx-auto">
            Finden Sie den Job, der zu Ihnen passt. Auch für internationale Fachkräfte geeignet.
          </p>
          {/* Search Bar */}
          <div className="max-w-3xl mx-auto bg-white rounded-lg p-2 flex flex-col sm:flex-row gap-2 shadow-lg">
            <div className="flex-grow flex items-center px-4 py-2 bg-slate-50 rounded-md">
              <SafeIcon icon={FiSearch} className="text-slate-400 mr-3" />
              <input
                type="text"
                placeholder="Jobtitel, Stichwort oder Ort..."
                className="bg-transparent w-full focus:outline-none text-slate-800"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <button className="bg-cyan-600 hover:bg-cyan-500 text-white px-8 py-3 rounded-md font-medium transition-colors sm:w-auto w-full">
              Suchen
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar / Filters */}
          <div className="lg:w-1/4">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 sticky top-28">
              <div className="flex items-center gap-2 font-bold text-blue-900 mb-6 pb-4 border-b border-slate-100">
                <SafeIcon icon={FiFilter} /> Branchen
              </div>
              <div className="space-y-2">
                {categories.map(cat => (
                  <label key={cat} className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="radio"
                      name="category"
                      value={cat}
                      checked={filterCategory === cat}
                      onChange={(e) => setFilterCategory(e.target.value)}
                      className="text-cyan-600 focus:ring-cyan-500 w-4 h-4 cursor-pointer"
                    />
                    <span className={`text-sm group-hover:text-cyan-600 transition-colors ${filterCategory === cat ? 'text-cyan-600 font-medium' : 'text-slate-600'}`}>
                      {cat}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Job List */}
          <div className="lg:w-3/4">
            <div className="mb-6 text-slate-500 text-sm">
              <span className="font-bold text-blue-900">{filteredJobs.length}</span> Stellenangebote gefunden
            </div>
            
            <div className="space-y-4">
              {filteredJobs.length > 0 ? (
                filteredJobs.map(job => (
                  <Link 
                    to={`/jobs/${job.id}`}
                    key={job.id}
                    className="block bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md hover:border-cyan-400 transition-all group"
                  >
                    <div className="flex flex-col sm:flex-row justify-between sm:items-start gap-4">
                      <div>
                        <h3 className="text-xl font-bold text-blue-900 mb-2 group-hover:text-cyan-600 transition-colors">
                          {job.title}
                        </h3>
                        <div className="flex flex-wrap gap-4 text-sm text-slate-500 mb-3">
                          <span className="flex items-center gap-1"><SafeIcon icon={FiMapPin} /> {job.location}</span>
                          <span className="flex items-center gap-1"><SafeIcon icon={FiBriefcase} /> {job.category}</span>
                          <span className="flex items-center gap-1"><SafeIcon icon={FiClock} /> {job.type}</span>
                        </div>
                        <p className="text-slate-600 text-sm line-clamp-2">{job.desc}</p>
                      </div>
                      
                      <div className="flex flex-col items-start sm:items-end gap-3 shrink-0">
                        <span className="text-xs text-slate-400 bg-slate-50 px-2 py-1 rounded inline-block">{job.date}</span>
                        <span className="text-cyan-600 font-medium text-sm group-hover:underline">Details ansehen &rarr;</span>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div className="bg-white p-12 rounded-xl text-center border border-slate-200">
                  <SafeIcon icon={FiSearch} className="h-12 w-12 text-slate-300 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-slate-900 mb-2">Keine passenden Jobs gefunden</h3>
                  <p className="text-slate-500">Bitte passen Sie Ihre Suchkriterien an.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Jobs;